// import React from 'react'
// import { Outlet, useNavigate } from 'react-router-dom'
// import { useAppSelector } from '../../../redux/hooks'
// import { selectUserData } from '../../../redux/actions/login/loginSlice'
// import User, { RoleType } from '../../../models/User'
// import authService from '../../../services/auth.service'

// const AffilateMain = () => {
//   const userState = useAppSelector<{ user: User }>(selectUserData)
//   const navigate = useNavigate()
// console.log(userState.user.role)
//   // Auth check
//   React.useEffect(() => {
//     const auth = authService.isAffiliateLoggedIn()
//     if (!auth ) {
//       return navigate('/affilate/login')
//     }
//   }, [userState.user])

//   return (
//     <div className="affilate-main">
//       {/* Add affiliate specific header/sidebar here */}
//       <div className="main-content">
//         <Outlet />
//       </div>
//       {/* Add affiliate specific footer here */}
//     </div>
//   )
// }

// export default AffilateMain

import React, { useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../redux/hooks'
import { selectUserData } from '../../../redux/actions/login/loginSlice'
import User, { RoleType } from '../../../models/User'
import authService from '../../../services/auth.service'
import Sidebar from './elements/sidebar'
import Header from './elements/header'

import './style.css'

const AffilateMain = () => {
  const userState = useAppSelector<{ user: User }>(selectUserData)
  const navigate = useNavigate()
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false)
  const [isSidebarHidden, setIsSidebarHidden] = useState(false)

  // Auth check
  React.useEffect(() => {
    const auth = authService.isAffiliateLoggedIn()
    if (!auth) {
      return navigate('/affilate/login')
    }
  }, [userState.user, navigate])

  const handleLogout = () => {
    authService.logoutAffiliate()
    navigate('/affilate/login')
  }

  return (
    <div className={`affiliate-layout ${isSidebarCollapsed ? 'sidebar-collapsed' : ''} ${isSidebarHidden ? 'sidebar-hidden' : ''}`}>
      <Sidebar 
        onToggleCollapse={setIsSidebarCollapsed}
        onToggleHidden={setIsSidebarHidden}
      />
      
      <div className="main-wrapper">
        <Header 
          username={userState.user?.username}
          onLogout={handleLogout}
        />
        
        <main className="main-content">
          <Outlet />
        </main>

  
      </div>
    </div>
  )
}

export default AffilateMain
